import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-responsive-modal';
import { connect } from 'react-redux';
import { formatDateTime } from '../../utils/Formatters';
import { useTranslation } from 'react-i18next';

import { showAsqSurveyResultsParentEmailSendoutConfirmationModal, loadAsqSurveyResultsParentEmailSendout } from 'actions/asq';
import { closeIconPath } from 'containers/modals/ModalRoot';

const PlayerSurveyResultsParentEmailSendout = (props) => {
  const { t } = useTranslation();
  const [moreInfoOpen, setMoreInfoOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const onEnqueue = props.onEnqueue;
  const showModal = () => {
    props.showAsqSurveyResultsParentEmailSendoutConfirmationModal({
      onConfirm: onEnqueue,
    });
  };

  const handleMoreInfoClick = async (e) => {
    e.preventDefault();
    setMoreInfoOpen(true);
    setIsLoading(true);
    await props.loadAsqSurveyResultsParentEmailSendout(props.surveyId, 0);
    setIsLoading(false);
  };

  return (
    <>
      <div className='u-flex u-flex-column'>
        <button
          className="o-sp-button o-sp-button--base o-sp-button--primary o-sp-button--block u-float--right c-send-parent-message-button"
          onClick={showModal}
        >
          <span className='u-txt--small'>
            <b>
              <i className='fa fa-envelope-o u-margin-right--small'></i>
              {t('player.sendResultsEmail')}
            </b>
          </span>
        </button>

        <div className='c-locale-legend'>
          <a href="#" onClick={handleMoreInfoClick}>{t('player.clickToSeeSendouts')}</a>
        </div>
      </div>
      <Modal
        classNames={{ overlay: 'o-modal__wrap', modal: 'o-modal o-modal__min-height row column u-margin-top--large' }}
        closeIconSvgPath={closeIconPath()}
        closeOnOverlayClick={true}
        open={moreInfoOpen}
        onClose={() => setMoreInfoOpen(false)}
        center
      >
        <div className='u-padding--base'>
          <h3 className='u-margin-bottom--base'>{t('player.resultEmailSendoutsHistory')}</h3>
          <div style={{ overflowY: 'auto', maxHeight: 'calc(90vh - 150px)' }}>
            {isLoading ? (
              <div style={{ textAlign: 'center', padding: '40px 20px' }}>
                <i className='o-spinner-dual'></i>
              </div>
            ) : props.resultsParentEmailSendout.partnerActions && props.resultsParentEmailSendout.partnerActions.length > 0 ? (
              <table className='o-table o-table--bordered' style={{ width: '100%' }}>
                <thead>
                  <tr>
                    <th>{t('asq.followUp.sentBy')}</th>
                    <th>{t('asq.followUp.sentAt')}</th>
                  </tr>
                </thead>
                <tbody>
                  {props.resultsParentEmailSendout.partnerActions.map((action, index) => (
                    <tr key={index}>
                      <td>{action.sentBy}</td>
                      <td>{action.sentAt ? formatDateTime(action.sentAt) : '-'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div style={{ textAlign: 'center', padding: '40px 20px' }}>
                <p style={{ color: '#999', fontSize: '16px' }}>{t('player.noEmailSendoutsYet')}</p>
              </div>
            )}
          </div>
        </div>
      </Modal>
    </>
  );
};

PlayerSurveyResultsParentEmailSendout.propTypes = {
  surveyId: PropTypes.number.isRequired,
  resultsParentEmailSendout: PropTypes.object.isRequired,
  onEnqueue: PropTypes.func.isRequired,
  showAsqSurveyResultsParentEmailSendoutConfirmationModal: PropTypes.func.isRequired,
  loadAsqSurveyResultsParentEmailSendout: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  showAsqSurveyResultsParentEmailSendoutConfirmationModal,
  loadAsqSurveyResultsParentEmailSendout,
};

export default connect(
  null,
  mapDispatchToProps,
)(PlayerSurveyResultsParentEmailSendout);
